<template>
<div style="width:100%;height:500px;">
  
   <br/>
     <Row><Col span="12" offset="10"><div class="myTitle" >任务记录</div></Col></Row>
    <br>
    <Row>
        <Col span="24">
            <Row>
                <div class="queryForm">
                    <Form ref="queryFormRef" :model="queryForm" :label-width="60" inline>
                        
                         <FormItem label="关键词" prop="keyword" >
                            <Input v-model="queryForm.keyword" placeholder="关键词 "></Input>
                        </FormItem>
                        <Button type="info"  @click="queryBtn" >查询</Button>
	                    <Button type="success"  @click="resetQueryForm">重置</Button>
                    </form>
                </div>
            </Row>
            
        
             <br>
            <Row>
                <Col span="24">
                        <Table :loading="loading" @on-selection-change="selectRow"
                               border ref="table" stripe :columns="columns4" :data="listData">
                            <template slot-scope="{ row }" slot="name">
                                <strong>{{ row.name }}</strong>
                            </template>
                           
                        </Table>
                 </Col>
            </Row>
            <Row>
                <Col span="24">
                	<div>
                        <Footer>
                            <Page show-sizer show-total :total="rowCount" :current="current"
                                  :page-size="pageSize"  @on-change="changePage"
                                  @on-page-size-change="changeSize" />
                        </Footer>
                    </div>
            	</Col>
            </Row>
        </Col>
    </Row>
      
    </div>
    
</template>

<script>
    
    export default {
        components: {
            
        },
        methods: {
           

            loadPage() {
                let url = `/api/tasks/record`
                this.req({
                    url: url,
                    method: 'post',
                    data:{
                      keyword:this.queryForm.keyword,
                      p: this.current,
                      pageSize: this.pageSize,
                    }
                }).then(resp => {
                    this.buildPageData(resp.data.page)
                    this.loading = false
                }).catch(error => {
                   this.$Message.error('服务器错误:' + error)
            	})
            },
            changePage(curPage) {
                this.loading = true
                this.current = curPage
                this.loadPage()
            },

            changeSize(pageSize) {
                this.pageSize = pageSize
                this.loading = true
                this.loadPage()
            },
            buildPageData(dataObj) {
                this.listData = dataObj.list;
                this.pageSize = dataObj.size;
                this.rowCount = dataObj.rowCount;
                this.currentPage = dataObj.p;
            },
            queryBtn(){
                this.current = 1
                this.loadPage()
            },
           
            selectRow(selection) {
                this.selectRows = selection;
            },
            resetQueryForm() {
             	this.$refs["queryFormRef"].fields.forEach(function (e) {
		           e.resetField()
		        })
            },
           
         
        },
        mounted: function () {
            this.loadPage()
        },
        data() {
            return {
                listData: [],
                pageSize: 10,
                current: 1,
                rowCount: 0,
                loading: true,
                selectRows: [],
                deleteIds: [],
                columns4: [{
                        type: 'index',
                        title: '序号',
	                    width: 60,
	                    align: 'center',
                    },
                    {
                        title: '检索关键词',
                        key: 'keyword' ,
                        align: 'center',
                    }, 
           			{
                        title: '检索时间',
                        key: 'createTime' ,
                        align: 'center',
                    },{
                        title: '检索执行人',
                        key: 'taskExecutor' ,
                        align: 'center',
                    },{
                        title: '检索结果条数',
                        key: 'rowCount' ,
                        align: 'center',
                    }
                ],

                //查询表单的初始值
                queryForm: {
                    keyword:'',
                }
            }
        },

    }
</script>

<style scoped>
.myTitle{
      font-size: 20px;
      font-weight: 700;
     }
</style>


// WEBPACK FOOTER //
// src/pages/platform/task/RecordTask.vue